"use client";

import React from "react";
import { PhoneCall, Cloud, MonitorSmartphone, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: PhoneCall,
  title: "CENTRAL TELEFÓNICA IP ON-PREMISE",
  description: <>
        Hasta 3.000 usuarios y 450 llamadas simultáneas. IVR, colas de llamadas, softphones multiplataforma
      </>
}, {
  icon: Cloud,
  title: "APP PARA CONECTIVIDAD REMOTA DE USUARIOS",
  description: <>
        <span className="font-semibold text-foreground">Configuración automática:</span> solo se necesita Internet. Voz, video y colaboración desde cualquier dispositivo
      </>
}, {
  icon: MonitorSmartphone,
  title: "APLICACIÓN MÓVIL Y DE ESCRITORIO",
  description: <>
        Aprovisionamiento, actualizaciones y monitoreo centralizado
      </>
}, {
  icon: Users,
  title: "VIDEOCONFERENCIA INCLUIDA",
  description: <>
        Sin esfuerzo de IT<br />
        <span className="font-semibold text-primary uppercase mt-1 block">SIN COSTOS ADICIONALES</span>
      </>
}];
export default function HybridConnectivityBenefits() {
  const introReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const heroReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const featuresReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hybrid-connectivity-benefits" className="bg-background py-10 md:py-14 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div ref={introReveal.ref} className={`max-w-3xl mx-auto text-center mb-8 md:mb-10 transition-all duration-700 ease-out ${introReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl md:text-3xl font-default font-semibold text-primary mb-4">
            ¡Hola!
          </h2>
          <p className="text-xl md:text-2xl font-default text-primary/80 leading-relaxed">
            Cuéntanos tu necesidad y te mostraremos cómo puedes conectar y colaborar de forma segura con tu equipo remoto.
          </p>
        </div>

        <div ref={heroReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-8 md:mb-10 transition-all duration-700 delay-200 ease-out ${heroReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] md:aspect-auto md:h-[400px]">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/remote_team_collaboration.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/remote_team_collaboration.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/remote_team_collaboration.png-wvc-sizes" alt="Mujer trabajando remotamente" className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="flex flex-col items-start justify-center space-y-8 md:pl-8">
            <h3 className="text-3xl md:text-4xl font-default font-bold text-foreground leading-tight">
              Conecta a tu equipo remoto con seguridad y sin complicaciones
            </h3>
            <Button asChild size="lg" className="text-base px-8 py-6 rounded-lg shadow-md">
              <Link to="#">
                Agenda una demostración
              </Link>
            </Button>
          </div>
        </div>

        <div ref={featuresReveal.ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 transition-all duration-700 delay-400 ease-out ${featuresReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-6 p-4 rounded-lg bg-primary/5 text-primary group-hover:bg-primary/10 transition-colors duration-300">
                  <Icon className="w-12 h-12 stroke-[1.5]" />
                </div>
                <h4 className="text-sm font-default font-bold text-primary uppercase tracking-wide mb-3 min-h-[40px] flex items-center justify-center">
                  {feature.title}
                </h4>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>

      </div>
    </section>;
}